import { render } from "./TutorVoicePicker.vue?vue&type=template&id=0b4ce70d&scoped=true"
import script from "./TutorVoicePicker.vue?vue&type=script&lang=js"
export * from "./TutorVoicePicker.vue?vue&type=script&lang=js"

import "./TutorVoicePicker.vue?vue&type=style&index=0&id=0b4ce70d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4ce70d"]])

export default __exports__